module.exports = __webpack_public_path__ + "static/media/colored-circles.33854199.svg";